var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"mm"}),_vm._m(0),_c('div',{staticClass:"banner-title"},[_c('p',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":"https://img0.baidu.com/it/u=3818555252,3433824264&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=800"}})])
}]

export { render, staticRenderFns }